var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { config } from '../../../../config/config';
import { VisitorCalendarActionCommand } from '../../../commands/pagination.query.command';
import { BaseComponent } from '../../../common/components/base.component';
import { FacebookLoginButtonComponent } from '../../../common/components/facebook.login.button/facebook.login.button.component';
import { PageSpinnerComponent } from '../../../common/components/page.spinner/page.spinner.component';
import { getRouteUrl, routeConfigs } from '../../../common/constants/route.config';
import { isNullOrUndefined } from '../../../common/extensions';
import { popupCenter } from '../../../common/extensions/browser/browser.extensions';
import { GoogleMapsService } from '../../../common/services/google.maps.service';
import { ModalService } from '../../../common/services/modal.service';
import { ConfigService } from '../../../services/config.service';
import { EventTimeService } from '../../../services/event.time.service';
import { ImageService } from '../../../services/image.service';
import { ShareService } from '../../../services/share.service';
import { VisitorApiService } from '../../../services/visitor.api.service';
import { VisitorCalendarStore, VisitorDataCache } from '../../../stores/visitor.calendar.store';
import { constantConfigs } from '../../../common/constants/constant';
var VisitorEventDetailsComponent = /** @class */ (function (_super) {
    __extends(VisitorEventDetailsComponent, _super);
    function VisitorEventDetailsComponent(router, activatedRoute, visitorCalendarStore, visitorApiService, googleMapService, imageService, modalService) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.activatedRoute = activatedRoute;
        _this.visitorCalendarStore = visitorCalendarStore;
        _this.visitorApiService = visitorApiService;
        _this.googleMapService = googleMapService;
        _this.imageService = imageService;
        _this.modalService = modalService;
        _this.lat = ConfigService.config.google.USCenter.lat;
        _this.lng = ConfigService.config.google.USCenter.lng;
        _this.mapZoom = 14;
        _this.simpleMenu = true;
        _this.isLoading = true;
        _this.actionCommand = new VisitorCalendarActionCommand();
        _this.featuresToggle = {
            tripPlanner: false,
            placeCalendar: true,
        };
        _this.hideIconMapStyler = ConfigService.config.google.hideMapBusinessIconStyles;
        return _this;
    }
    VisitorEventDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        var _a = this.allRouteParams, hubName = _a.hubName, category = _a.category, menuType = _a.menuType;
        this.category = category || 'all';
        this.hubName = hubName;
        this.simpleMenu = menuType === 'simple';
        this.eventHost = constantConfigs.facebook.host;
        this.loadEvents();
        this.visitorApiService.getToggles(this.hubName).subscribe(function (toggle) {
            if (toggle) {
                _this.featuresToggle.tripPlanner = isNullOrUndefined(toggle.tripPlanner) ? true : toggle.tripPlanner;
                _this.featuresToggle.placeCalendar = isNullOrUndefined(toggle.placeCalendar) ? true : toggle.placeCalendar;
            }
        });
    };
    // public close() {
    //     this.sideBar.close();
    // }
    VisitorEventDetailsComponent.prototype.jumpFacebook = function () {
        if (this.event.eventLink && this.event.eventLink !== 'undefined') {
            window.open(this.event.eventLink);
        }
        else if (this.event.socialName == 'eventbrite') {
            window.open('https://www.eventbrite.com/e/' + this.event.id);
        }
        else if (this.event.socialName == 'facebook') {
            window.open('https://www.facebook.com/' + this.event.id);
        }
        else if (this.event.socialName == 'eventful') {
            window.open('http://auckland.eventful.com/events/' + this.event.id);
        }
    };
    VisitorEventDetailsComponent.prototype.gotoEventCalendar = function () {
        // if (this.isMobile&&isSafari()) {
        //     setTimeout(() => {
        //         this.actionCommand.isEventCalendar = true;
        //         this.actionCommand.queryCommand.category = 'All';
        //         this.actionCommand.queryCommand.choice = null;
        //         this.actionCommand.queryCommand.isCustom = null;
        //         this.actionCommand.queryCommand.mostAttended = null;
        //         this.actionCommand.queryCommand.feedId = null;
        //         this.visitorCalendarStore.actionCommand.next(this.actionCommand);
        //     });
        // }
        this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.eventCalendar, {
            hubName: this.hubName
        }), { skipLocationChange: this.noChangeUrlWhenRedirect });
        this.actionCommand.isEventCalendar = true;
        this.actionCommand.queryCommand.category = 'All';
        this.actionCommand.queryCommand.choice = null;
        this.actionCommand.queryCommand.isCustom = null;
        this.actionCommand.queryCommand.mostAttended = null;
        this.actionCommand.queryCommand.feedId = null;
        this.visitorCalendarStore.actionCommand.next(this.actionCommand);
    };
    VisitorEventDetailsComponent.prototype.gotoPlaceCalendar = function () {
        // if (this.isMobile&&isSafari()) {
        //     setTimeout(() => {
        //         this.category = 'all';
        //         this.actionCommand.isEventCalendar = false;
        //         this.visitorCalendarStore.actionCommand.next(this.actionCommand);
        //     });
        // }
        this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.placeCalendar, {
            hubName: this.hubName,
            category: this.category
        }), { skipLocationChange: this.noChangeUrlWhenRedirect });
        this.category = 'all';
        this.actionCommand.isEventCalendar = false;
        this.visitorCalendarStore.actionCommand.next(this.actionCommand);
    };
    VisitorEventDetailsComponent.prototype.gotoDetails = function (id) {
        var _this = this;
        var hubName = this.allRouteParams.hubName;
        this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.eventDetails, {
            hubName: hubName,
            eventId: id
        }), { skipLocationChange: this.noChangeUrlWhenRedirect });
        setTimeout(function () {
            _this.loadEvents();
        });
    };
    VisitorEventDetailsComponent.prototype.showInfoWindow = function (marker) {
        if (!marker._isOpen) {
            marker._openInfoWindow();
        }
        clearTimeout(this.timeout);
    };
    VisitorEventDetailsComponent.prototype.hideInfoWindow = function (marker) {
        this.timeout = setTimeout(function () {
            marker._closeInfoWindow();
        }, 1500);
    };
    VisitorEventDetailsComponent.prototype.onSideNavScroll = function (event) {
        event.stopPropagation();
    };
    VisitorEventDetailsComponent.prototype.getDirectionToEventAddress = function () {
        var url = config.eventShare.googleMapGetDirection
            .replace('${address}', encodeURIComponent(this.event.address.address));
        window.open(url, '_blank');
    };
    VisitorEventDetailsComponent.prototype.shareEventToFacebook = function () {
        // let href = (window.location.href.indexOf('test/events/5e4d1d23df1890118940d617') >= 0 || window.location.href.indexOf('test/events/5e4d1dc0df1890118940d61d') >= 0) ? this.event.eventLink : window.location.href;
        // href = href.indexOf('test/events/5e4d1d23df1890118940d615') >= 0 ? 'https://imgoingcalendar.com/assets/pages/recognized.categories.html' : href;
        var href = this.event.eventLink || window.location.href;
        var params = {
            method: 'share',
            href: href,
            quote: (this.event.title || this.event.name) + ' - ' + this.event.description,
        };
        FB.ui(params, function () {
        });
    };
    VisitorEventDetailsComponent.prototype.tweetEvent = function () {
        var shareLink = config.eventShare.tweet
            .replace('${text}', this.event.name)
            .replace('${url}', encodeURIComponent(window.location.href));
        popupCenter(shareLink);
    };
    VisitorEventDetailsComponent.prototype.mailEvent = function () {
        if (this.isMobile) {
            window.open(ShareService.toMailableEvent(this.event, window.location.href));
        }
        else {
            window.location.href = ShareService.toMailableEvent(this.event, window.location.href);
        }
    };
    VisitorEventDetailsComponent.prototype.initFacebookStatus = function () {
        var _this = this;
        this.authResponse = FacebookLoginButtonComponent.authResponse ? FacebookLoginButtonComponent.authResponse.authResponse : null;
        if (FacebookLoginButtonComponent.isUserLoggedWithFacebook) {
            FB.api(config.facebook.graphApi.events
                .replace('${userId}', FacebookLoginButtonComponent.authResponse.authResponse.userID), { access_token: this.authResponse.accessToken }, function (eventsResponse) {
                if (!eventsResponse.error && eventsResponse.data.length > 0) {
                    _this.joinedEventIds = eventsResponse.data.map(function (x) { return x.id; });
                }
            });
            //this.getFacebookEventFeed();
        }
    };
    VisitorEventDetailsComponent.prototype.getFacebookEventFeed = function () {
        var _this = this;
        if (this.event && this.event.id &&
            FacebookLoginButtonComponent.isUserLoggedWithFacebook &&
            this.event.socialName != 'eventbrite' && this.event.socialName != 'eventful') {
            FB.api(config.facebook.graphApi.eventPosts
                .replace('${accessToken}', FacebookLoginButtonComponent.userAccessToken)
                .replace('${eventId}', this.event.id), function (response) {
                _this.eventFeedPaging = response.paging;
                if (!!response.error) {
                    console.error(response.error);
                    return;
                }
                _this.updateEventFeeds(response.data);
            });
        }
    };
    VisitorEventDetailsComponent.prototype.getNextFacebookEventFeed = function (event) {
        var _this = this;
        FB.api(this.eventFeedPaging.next, function (response) {
            event.complete();
            _this.eventFeedPaging = response.paging;
            if (!!response.error) {
                console.error(response.error);
                return;
            }
            _this.updateEventFeeds(_this.eventFeeds.concat(response.data));
        });
    };
    VisitorEventDetailsComponent.prototype.updateEventFeeds = function (eventFeeds) {
        this.eventFeeds = eventFeeds;
        this.eventFeeds.forEach(function (x) {
            x.from.link =
                config.facebook.graphApi.profile.replace('${userId}', x.from.id);
            x.from.picture =
                config.facebook.graphApi.profilePictureSquare.replace('${userId}', x.from.id);
        });
    };
    VisitorEventDetailsComponent.prototype.getEvents = function () {
        var limit = config.searchLimit; // 0 represents no limit, but seems only 9 records can be found if this set to 0
        return this.visitorApiService.getEvents(this.hubName, { page: 1, limit: limit, category: 'All' });
    };
    VisitorEventDetailsComponent.prototype.loadEvents = function () {
        var _this = this;
        this.isLoading = true;
        this.loadingSpinner.show();
        var eventId = this.allRouteParams.eventId;
        // let allEventsWithCurrent = JSON.parse(localStorage.getItem(localStorageKeys.visitorEvents));
        var allEventsWithCurrent = VisitorDataCache.events;
        var needToLoadEvents = false;
        if (!allEventsWithCurrent) {
            needToLoadEvents = true;
        }
        else {
            this.event = allEventsWithCurrent.first(function (x) { return x._id === eventId; });
            if (!this.event) {
                needToLoadEvents = true;
            }
            else {
                EventTimeService.formatEventTime(allEventsWithCurrent);
                this.setMeta();
            }
        }
        if (needToLoadEvents) {
            this.getEvents().subscribe(function (data) {
                if (data && data.length) {
                    EventTimeService.formatEventTime(data);
                    _this.event = data.first(function (x) { return x._id === eventId; });
                    if (_this.event && _this.event.socialName === config.eventbrite) {
                        _this.eventHost = constantConfigs.eventbrite.host;
                    }
                    _this.events = data.filter(function (x) { return x._id !== _this.event._id; });
                    if (!_this.event.address || isNullOrUndefined(_this.event.address.lat)) {
                        _this.mapZoom = ConfigService.config.google.fullUSMapZoom;
                    }
                    if (_this.event.description && _this.event.description !== 'undefined') {
                        setTimeout(function () {
                            _this.description.nativeElement.innerHTML = _this.event.description;
                        });
                    }
                    else {
                        setTimeout(function () {
                            _this.description.nativeElement.innerHTML = '(no description)';
                        });
                    }
                    _this.fitBounds();
                    _this.isLoading = false;
                    _this.loadingSpinner.hide();
                    // localStorage.setItem(localStorageKeys.visitorEvents, JSON.stringify(data.slice(0, 1000)));
                    VisitorDataCache.events = data;
                    if (!_this.event) {
                        _this.modalService.showErrorModal('Event id is wrong!');
                        _this.gotoPlaceCalendar();
                        return;
                    }
                    _this.setMeta();
                }
            });
            return;
        }
        if (this.event.socialName === config.eventbrite) {
            this.eventHost = constantConfigs.eventbrite.host;
        }
        this.events = allEventsWithCurrent.filter(function (x) { return x._id !== _this.event._id; });
        if (this.event.description && this.event.description !== 'undefined') {
            setTimeout(function () {
                _this.description.nativeElement.innerHTML = _this.event.description;
            });
        }
        else {
            setTimeout(function () {
                _this.description.nativeElement.innerHTML = '(no description)';
            });
        }
        this.fitBounds();
        this.isLoading = false;
        this.loadingSpinner.hide();
        // this.getEvents().subscribe(data => {
        //     this.events = data;
        //     localStorage.setItem(localStorageKeys.visitorEvents, JSON.stringify(data.slice(0, 1000)));
        //     VisitorDataCache.events = data;
        // });
    };
    VisitorEventDetailsComponent.prototype.fitBounds = function () {
        var _this = this;
        this.googleMapService.getGoogle().then(function () {
            _this.latLngBounds = new google.maps.LatLngBounds();
            _this.events.forEach(function (x) {
                if (x.address && x.address.lat && x.address.lng) {
                    _this.latLngBounds.extend(new google.maps.LatLng(x.address.lat, x.address.lng));
                }
            });
        });
    };
    VisitorEventDetailsComponent.prototype.setMeta = function () {
        var metaList = document.getElementsByTagName("meta");
        for (var i = 0; i < metaList.length; i++) {
            if (metaList[i].getAttribute("property") == "og:description") {
                metaList[i].content = this.event.description;
            }
            if (metaList[i].getAttribute("property") == "og:image") {
                metaList[i].content = this.imageService.imageSource(this.event);
            }
            if (metaList[i].getAttribute("property") == "og:title") {
                metaList[i].content = this.event.title || this.event.name;
            }
            if (metaList[i].getAttribute("property") == "og:url") {
                metaList[i].content = window.location.href;
            }
        }
    };
    return VisitorEventDetailsComponent;
}(BaseComponent));
export { VisitorEventDetailsComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/event.details/visitor.event.details.component.ts.pre-build-optimizer.js